import { useState } from "react";
import * as songsApi from "../../api/songsApi";
import { failureMessage } from "../../api/client";

const ISSUE_TYPES = [
  "Incorrect song title",
  "Incorrect lyrics",
  "Wrong chords",
  "Formatting issue",
  "Misspelling",
  "Missing section or verse",
  "Other",
];

const ReportIssueForm = ({ song, onDone }) => {
  const [selected, setSelected] = useState([]);
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [failure, setFailure] = useState(null);

  const toggle = (type) =>
    setSelected((current) => (current.includes(type) ? current.filter((t) => t !== type) : [...current, type]));

  const canSend = status !== "sending" && (selected.length > 0 || description.trim().length > 0);

  const submit = async (event) => {
    event.preventDefault();
    if (!canSend) return;
    setStatus("sending");
    try {
      await songsApi.reportIssue({
        songId: song.Id,
        songTitle: song.Title,
        issueTypes: selected,
        description: description.trim(),
      });
      setStatus("sent");
    } catch (error) {
      console.error("Could not send the report", error);
      setFailure(failureMessage(error, "Could not send the report, please try again."));
      setStatus("error");
    }
  };

  if (status === "sent") {
    return (
      <div className="stack">
        <p className="card-title">Thanks! Your report has been sent.</p>
        <button type="button" className="btn btn-md btn-primary" onClick={onDone}>
          Close
        </button>
      </div>
    );
  }

  return (
    <form className="stack" onSubmit={submit}>
      <div className="row-title">{song.Title}</div>
      <div className="check-list" role="group" aria-label="What is wrong">
        {ISSUE_TYPES.map((type) => (
          <button key={type} type="button" className="check-item" aria-pressed={selected.includes(type)} onClick={() => toggle(type)}>
            <span aria-hidden="true">{selected.includes(type) ? "☑" : "☐"}</span>
            {type}
          </button>
        ))}
      </div>
      <textarea className="field field-area" style={{ minHeight: 90 }} rows={3} value={description} onChange={(event) => setDescription(event.target.value)} placeholder="What should it say?" aria-label="Description" />
      {status === "error" && (
        <p className="error-text" role="alert">
          {failure || "Could not send the report, please try again."}
        </p>
      )}
      <button type="submit" className="btn btn-md btn-primary" disabled={!canSend}>
        {status === "sending" ? "Sending…" : "Send report"}
      </button>
    </form>
  );
};

export default ReportIssueForm;
